(function() { window.GUID_1d420c66_62a2_470b_983b_d6b25b221813 = { getGuid: function() { return "1d420c66-62a2-470b-983b-d6b25b221813"; } }; })();
var CS;
(function (CS) {
    var Ads;
    (function (Ads) {
        var countUntilNextAdd = 0;
        var showAdEveryX = 10;
        // Ne peux pas être nommé ShowFullscreenAd pour ne pas etre en conflit avec la méthode native
        function ShowFullscreen(pageValue = 1) {
            if (CS.CommonData.Current.IsPremium ||
                CS.CommonData.Current.IsPremiumEssential) {
                return;
            }
            //Limité a 1 ad aux 2 heures dans admob
            CS.NativeApp.NA_ShowFullscreenAd("false");
            //Disabled until it works better
            //countUntilNextAdd += pageValue;
            //if (countUntilNextAdd >= showAdEveryX) {
            //    countUntilNextAdd -= showAdEveryX;
            //    console.log("ShowFullScreenAd");
            //    //Disable native until we fix the close button under the status bar on ios
            //    //if (typeof (ShowFullscreenAd) == "function") {
            //    //    ShowFullscreenAd();
            //    //}
            //    //else {
            //        CS.Controls.Popup.ShowAjaxModal(Url.CSUrl("fullscreenad"), null, function(popup) {
            //            GoogleAds.BindAds(true);
            //        }, null);
            //    //}
            //}
        }
        Ads.ShowFullscreen = ShowFullscreen;
        function PreLoadAd() {
            if (!CS.CommonData.Current.IsPremium &&
                !CS.CommonData.Current.IsPremiumEssential) {
                CS.NativeApp.NA_LoadFullscreenAd(null);
            }
        }
        Ads.PreLoadAd = PreLoadAd;
        function RefreshEzoicAds($container) {
            if (!CS.GlobalConst.UseEzoicAds || !CS.CommonData.Current.AdsEnabled) {
                if (window.ezstandalone) {
                    if (typeof ezstandalone.destroyAll === "function") {
                        ezstandalone.destroyAll();
                    }
                    ezstandalone.enabled = false;
                }
                return;
            }
            let $top = $container !== null && $container !== void 0 ? $container : CS.DOM.$sectionMiddle;
            let ads = $top.find(".cs-ezoic-ad");
            let adnumbers = ads
                .map((i, o) => {
                let num = parseInt(o.id.replace("ezoic-pub-ad-placeholder-", ""));
                return num;
            })
                .get();
            try {
                window.ezstandalone = window.ezstandalone || [];
                ezstandalone.cmd = ezstandalone.cmd || [];
                CS.Helper.log("ezoic", "pre ezoic cmd " +
                    ezstandalone.enabled +
                    " " +
                    JSON.stringify(adnumbers));
                ezstandalone.cmd.push(function () {
                    try {
                        if (!ezstandalone.enabled) {
                            ezstandalone.setEzoicAnchorAd(false);
                            ezstandalone.define(adnumbers);
                            ezstandalone.enable();
                            ezstandalone.display();
                            CS.Helper.log("ezoic", "cmd " + ezstandalone.enabled);
                        }
                        else {
                            if (typeof ezstandalone.destroyAll === "function") {
                                ezstandalone.destroyAll();
                            }
                            if (typeof ezstandalone.define === "function") {
                                ezstandalone.define(adnumbers);
                            }
                            if (typeof ezstandalone.refresh === "function") {
                                ezstandalone.refresh();
                            }
                            CS.Helper.log("ezoic", "cmd refresh " + JSON.stringify(adnumbers));
                        }
                    }
                    catch (e) {
                        console.error("ezoic " + JSON.stringify(e));
                    }
                });
            }
            catch (e) {
                console.error("ezoic " + JSON.stringify(e));
            }
        }
        Ads.RefreshEzoicAds = RefreshEzoicAds;
        function RefreshDynamicEzoicAds($container) {
            if (!CS.GlobalConst.UseEzoicAds || !CS.CommonData.Current.AdsEnabled) {
                return;
            }
            let $top = $container !== null && $container !== void 0 ? $container : CS.DOM.$sectionMiddle;
            let ads = $top.find(".cs-ezoic-ad");
            let adnumbers = ads
                .map((i, o) => {
                let num = parseInt(o.id.replace("ezoic-pub-ad-placeholder-", ""));
                return num;
            })
                .get();
            if (ads.length > 0) {
                try {
                    window.ezstandalone = window.ezstandalone || [];
                    ezstandalone.cmd = ezstandalone.cmd || [];
                    ezstandalone.cmd.push(function () {
                        try {
                            if (!ezstandalone.enabled) {
                                ezstandalone.setEzoicAnchorAd(false);
                                ezstandalone.define(adnumbers);
                                ezstandalone.enable();
                                ezstandalone.display();
                            }
                            else {
                                ezstandalone.displayMore(adnumbers);
                            }
                        }
                        catch (_a) { }
                    });
                }
                catch (_a) { }
            }
        }
        Ads.RefreshDynamicEzoicAds = RefreshDynamicEzoicAds;
        function TryPremiumOrSubscribe(feature = CS.Enumeration.PremiumFeature.Generic, backOnCancel = false) {
            console.log("TryPremiumOrSubscribe " + feature);
            let canGoBack = true;
            const url = CS.Url.CSUrl("AskAdsForPremium");
            const data = {
                featureId: feature,
            };
            if (url != null && typeof url === "string") {
                //popup avec choix de essayer avec pub ou s'abbonner.  Devrait avoir un exemple et explication du feature
                CS.Controls.Popup.ShowAjaxModal(url, data, ({ popup }) => {
                    // OnLoad
                    $("#button-watch-ad").on("click", (e) => {
                        //pour debug
                        //canGoBack = false;
                        //CS.Ajax.Post('/general/unlockpremium', data, function () {
                        //    popup.Close();
                        //    CS.Nav.Refresh();
                        //});
                        $("body").offon("RewardAdFailedToLoad.trypremium", function () {
                            alert("Ad failed to load, you can try again");
                        });
                        $("body").offon("RewardAdSuccessful.trypremium", function () {
                            canGoBack = false;
                            CS.Ajax.Post("/general/unlockpremium", data, function () {
                                popup.Close();
                                CS.Nav.Refresh();
                            });
                        });
                        CS.NativeApp.NA_ShowRewardAd("true");
                    });
                    console.log("preload ad");
                    CS.NativeApp.NA_LoadRewardAd("");
                }, ({ popup }) => {
                    // OnClose
                    $("body").off("RewardAdFailedToLoad.trypremium");
                    $("body").off("RewardAdSuccessful.trypremium");
                    console.log("popup closed " + canGoBack + " " + backOnCancel);
                    if (canGoBack && backOnCancel) {
                        CS.Nav.GoBack();
                    }
                }, true);
            }
        }
        Ads.TryPremiumOrSubscribe = TryPremiumOrSubscribe;
    })(Ads = CS.Ads || (CS.Ads = {}));
})(CS || (CS = {}));

//# sourceMappingURL=cs-ads.js.map
